import Axios, { AxiosRequestConfig } from 'axios';

// Custom parameter serializer that converts bracket notation to dot notation
const customParamsSerializer = (params: Record<string, any>): string => {
    const urlParams = new URLSearchParams();

    const addParam = (key: string, value: any) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                value.forEach(v => urlParams.append(key, String(v)));
            } else {
                urlParams.append(key, String(value));
            }
        }
    };

    const processObject = (obj: Record<string, any>, prefix = '') => {
        Object.entries(obj).forEach(([key, value]) => {
            const fullKey = prefix ? `${prefix}.${key}` : key;

            if (value && typeof value === 'object' && !Array.isArray(value)) {
                // Handle nested objects (like pageable, criteria)
                processObject(value, fullKey);
            } else {
                addParam(fullKey, value);
            }
        });
    };

    processObject(params);
    return urlParams.toString();
};

export const AXIOS_INSTANCE = Axios.create({
    baseURL: '',
    paramsSerializer: {
        serialize: customParamsSerializer
    },
    withCredentials: true, // Include cookies for authentication
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add request interceptor for authentication and debugging
AXIOS_INSTANCE.interceptors.request.use(
    (config) => {
        console.log('Request URL:', config.url);
        console.log('Request params:', config.params);
        
        // Add CSRF token if available (common in Spring Security)
        const csrfToken = document.querySelector('meta[name="_csrf"]')?.getAttribute('content');
        const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.getAttribute('content');
        
        if (csrfToken && csrfHeader) {
            config.headers[csrfHeader] = csrfToken;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const customInstance = <T>(config: AxiosRequestConfig, options?: any): Promise<T> => {
    const source = Axios.CancelToken.source();
    const promise = AXIOS_INSTANCE({
        ...config,
        cancelToken: source.token
    }).then(({ data }) => data);

    // @ts-ignore
    promise.cancel = () => {
        source.cancel('Query was cancelled');
    };

    return promise;
};